import _extends from "@babel/runtime/helpers/esm/extends";
import { EModel, fieldsIBaseModel } from '@lumahealthhq/ui-model-types';
export var EWorkflowActionStage = /*#__PURE__*/function (EWorkflowActionStage) {
  EWorkflowActionStage["PostExtraction"] = "PostExtraction";
  EWorkflowActionStage["PostApproval"] = "PostApproval";
  return EWorkflowActionStage;
}({});
export var EFaxDocumentSingleActionInstanceStatus = /*#__PURE__*/function (EFaxDocumentSingleActionInstanceStatus) {
  EFaxDocumentSingleActionInstanceStatus["Scheduled"] = "scheduled";
  EFaxDocumentSingleActionInstanceStatus["Running"] = "running";
  EFaxDocumentSingleActionInstanceStatus["Completed"] = "completed";
  EFaxDocumentSingleActionInstanceStatus["Failed"] = "failed";
  return EFaxDocumentSingleActionInstanceStatus;
}({});
export var EFaxDocumentFullActionInstanceStatus = /*#__PURE__*/function (EFaxDocumentFullActionInstanceStatus) {
  EFaxDocumentFullActionInstanceStatus["InProgress"] = "in-progress";
  EFaxDocumentFullActionInstanceStatus["Completed"] = "completed";
  return EFaxDocumentFullActionInstanceStatus;
}({});
export var fieldsFaxDocumentActionInstance = _extends({}, fieldsIBaseModel, {
  actionStatuses: {
    type: 'Object',
    array: true
  },
  workflows: {
    type: 'Object',
    array: true
  },
  faxDocument: {
    type: 'ID',
    ref: EModel.FaxDocument
  },
  stage: {
    type: 'Option',
    values: EWorkflowActionStage
  },
  status: {
    type: 'Option',
    values: EFaxDocumentFullActionInstanceStatus
  }
});